const BASE_URL = process.env.REACT_APP_WP_REST_URL;

export const fetchEventsWithChildren = async () => {
  const response = await fetch(`${BASE_URL}/events_with_children`);
  const data = await response.json();
  return data;
};

export const fetchChildEvents = async (parentId) => {
  const response = await fetch(`${BASE_URL}/child_events/${parentId}`);
  const data = await response.json();
  return data;
};

export const fetchWordpressLink = async (id) => {
  const response = await fetch(`https://dig.watch/wp-json/wp/v2/event/${id}`);
  const data = await response.json();
  return data?.link || null;
};